<template>
  <swiper :options="swiperOption" class="swiper-container-common" ref="mySwiper">
    <swiper-slide class="" slideIndex=1>
      <div class="wrapslide bg">
        <yuimg class="bg" src="1/p1_bg.jpg?v=14"></yuimg>
        <yuimg class="p1_1" src="1/p1_1.png?v=2"></yuimg>
        <yuimg class="p1_2" effect="fadeInUp" delay="0" durtime="1.0" :isActiveT="isActive[1]" src="1/p1_2.png?v=2"></yuimg>
        <yuimg class="p1_3" effect="fadeInDown" delay="0.3" durtime="1.0" :isActiveT="isActive[1]" src="1/p1_3.png?v=2"></yuimg>

      </div>
    </swiper-slide>

    <swiper-slide class="swiper-no-swiping" slideIndex=2>
      <div class="bantouminghei"></div>
      <yuimg class="p2_1" v-tous="getred" src="2/p2_1.png?v=2"></yuimg>
    </swiper-slide>
  </swiper>
</template>
<script>
import { mapState } from "vuex";
import {
  resourcepath,
  commonswiper,
  netpost,
  kongzhiqi,
  tanc,
} from "../commonjs/commonfn.js";
import $ from "jquery";
import store from "@/store/";
export default {
  name: "swipermoban",
  data() {
    return {
      xxx: 1,
      sublimtinfo: { name: "11" },
      resourcepath: resourcepath,
      swiperOption: {
        direction: "vertical",
        preventLinksPropagation: false,
        effect: "fade",
        noSwiping: "true",
        on: {
          init: function () { },
          slideChangeTransitionEnd: () => {
            commonswiper(
              this.$refs.mySwiper.$swiper,
              ".swiper-container-common"
            );
            var slideIndex = parseInt(
              $(".swiper-container-common")
                .find(".swiper-slide-active")
                .find(".wrapslide")
                .attr("slideIndex")
            );
            store.commit("isActiveset", slideIndex);

          },
        },
      },
    };
  },
  components: {},
  created() { },
  watch: {

  },
  mounted() {
    window.mySwiper = this.$refs.mySwiper.$swiper;
  },
  methods: {
    testclick(b) {
      alert(b);
    },

    destroypage() {
      console.log("离开页面");
    },
    resload() {
      console.log('资源加载完成')
      store.commit("isActiveset", 1);
      commonswiper(this.$refs.mySwiper.$swiper, ".swiper-container-common");
    },
    refresh() {
      // 刷新页面加载的逻辑 清除组件data 和初始化组件即可

    },
    getred() {

      netpost('/' + kongzhiqi + '/getred', { "tableprename": "dahuahongbao" }).then(function (data) {

        if (data.code == 100) {
          let list = data.data;
          let red = list.red;
          store.commit('redset', red);
          store.commit('isshowp3set', 1);
          return false;
        } else {
          store.commit('gettipset', data.msg);
          tanc(data.msg, function () {
            store.commit('isshowp3set', 0);
            store.commit('isshowp4set', 1);
          });
        }
      })

    }
  },

  computed: {
    ...mapState(["isalljiazai", "isActive"]),
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/swipermoban.vue